import { Box } from "@mui/system"
import React from "react"

const StandardPaperContainer = ({children}: {children: React.ReactNode}) => {
    return <Box sx={{padding: "0 0.75rem"}}>
        {children}
    </Box>
}
export default StandardPaperContainer;